module.exports = __webpack_public_path__ + "static/img/arrow-down.1a9dc28a.svg";